/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { RecordGroup } from '../model/recordGroup';
import { RecordGroupCreateRequest } from '../model/recordGroupCreateRequest';
import { RecordGroupKeys } from '../model/recordGroupKeys';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class RecordGroupService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createRecordGroup
     * Creates a new record group.
     * @param recordGroupCreateRequest the information needed to create the record group.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recordGroupCreateRecordGroup(recordGroupCreateRequest: RecordGroupCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<RecordGroup>;
    public recordGroupCreateRecordGroup(recordGroupCreateRequest: RecordGroupCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecordGroup>>;
    public recordGroupCreateRecordGroup(recordGroupCreateRequest: RecordGroupCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecordGroup>>;
    public recordGroupCreateRecordGroup(recordGroupCreateRequest: RecordGroupCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (recordGroupCreateRequest === null || recordGroupCreateRequest === undefined) {
            throw new Error('Required parameter recordGroupCreateRequest was null or undefined when calling recordGroupCreateRecordGroup.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<RecordGroup>(`${this.configuration.basePath}/recordGroups`,
            recordGroupCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteRecordGroup
     * Deletes an existing record group by record code.
     * @param recordCode the record code.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recordGroupDeleteRecordGroup(recordCode: string, observe?: 'body', reportProgress?: boolean): Observable<RecordGroup>;
    public recordGroupDeleteRecordGroup(recordCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecordGroup>>;
    public recordGroupDeleteRecordGroup(recordCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecordGroup>>;
    public recordGroupDeleteRecordGroup(recordCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (recordCode === null || recordCode === undefined) {
            throw new Error('Required parameter recordCode was null or undefined when calling recordGroupDeleteRecordGroup.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<RecordGroup>(`${this.configuration.basePath}/recordGroups/${encodeURIComponent(String(recordCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getRecordGroup
     * Gets an existing record group by record code.
     * @param recordCode the record code.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recordGroupGetRecordGroup(recordCode: string, observe?: 'body', reportProgress?: boolean): Observable<RecordGroup>;
    public recordGroupGetRecordGroup(recordCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecordGroup>>;
    public recordGroupGetRecordGroup(recordCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecordGroup>>;
    public recordGroupGetRecordGroup(recordCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (recordCode === null || recordCode === undefined) {
            throw new Error('Required parameter recordCode was null or undefined when calling recordGroupGetRecordGroup.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RecordGroup>(`${this.configuration.basePath}/recordGroups/${encodeURIComponent(String(recordCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getRecordGroups
     * Gets a list of record group keys for all record groups defined in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recordGroupGetRecordGroups(observe?: 'body', reportProgress?: boolean): Observable<RecordGroupKeys>;
    public recordGroupGetRecordGroups(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecordGroupKeys>>;
    public recordGroupGetRecordGroups(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecordGroupKeys>>;
    public recordGroupGetRecordGroups(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RecordGroupKeys>(`${this.configuration.basePath}/recordGroups`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
